import apiService from './index'

// Types for Recent Updates API Response
export interface Tag {
  id: string
  name: string
}

export interface Assignee {
  board_person_id: string
  user_id: string
  fullName: string
  email: string
}

export interface RecentCard {
  type: 'task'
  id: string
  card_name: string
  description: string
  status: string
  priority: string
  rag: string
  due_date: string | null
  due_time: string | null
  boardId: string
  boardName: string
  boardStatus: string
  columnId: string
  columnName: string
  position: number
  key: string
  tags: Tag[]
  assignees: Assignee[]
  createdAt: string
  updatedAt: string
}

export interface RecentPage {
  type: 'page'
  id: string
  title: string
  description: string
  website_name: string
  status: string
  boardId: string
  boardName: string
  boardStatus: string
  createdByUserId: string
  file_attachments: string[]
  key: string
  pageNumber: number
  tags: Tag[]
  assignees: Assignee[]
  createdAt: string
  updatedAt: string
}

export interface RecentUpdatesResponse {
  success: boolean
  data: {
    cards: RecentCard[]
    pages: RecentPage[]
  }
}

export const getRecentUpdates = async (): Promise<{ data: RecentUpdatesResponse }> => {
  return await apiService.get(`${process.env.REACT_APP_BACKEND_URL_V3}/recent-updates`)
}
